<template>
  <section>
    <matricula-controller 
      :action="action"
      :step="step"
      :idMatricula="idMatricula"
      :auto="auto"
    />
  </section>
</template>


<script>
import MatriculaController from '@/components/matriculas/4/template/MatriculaController.vue'
export default {
  components: {
    MatriculaController
  },
  props: {
    action: String,
    step: String,
    idMatricula: [String, Number],
    auto: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      
    }
  }
}
</script>

<style lang="scss" scoped>

</style>